import { Component, OnInit } from '@angular/core'; 
import { AuthorizeService, AuthenticationResultStatus } from '../../../../src/api-authorization/authorize.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
 
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})

export class HomeComponent implements OnInit{
  public message = new BehaviorSubject<string>(null);

  constructor(private authorizeService: AuthorizeService, private router: Router) { }
   
  async ngOnInit() {
    const result = await this.authorizeService.isAuthenticated();
    if (result) {
      this.router.navigate(['/dashboard']);    
    } 
  } 
}
